var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRazorpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20025 7.22985L7.2402 14.7323H2.45166L3.42264 11.0414L9.20025 7.22985Z",
    fill: "#072654"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5485 1.78394L10.1471 14.7323H7.81314L10.1109 5.96336L6.58886 8.28525L7.21608 5.97542L13.5485 1.78394Z",
    fill: "#3395FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRazorpay);
export default __webpack_public_path__ + "static/media/razorpay.6511e27411ceeafba1bec784155c3815.svg";
export { ForwardRef as ReactComponent };